import { Injectable } from "@angular/core";
import { SSNMaskingStrategy } from "./ssn-masking.strategy";

@Injectable({
  providedIn: "any"
})
export class SSNMaskingDefaultStrategy extends SSNMaskingStrategy {
  constructor() {
    super();
  }

  getMask(): string {
    return "000-00-0000";
  }

  isHiddenInput(): boolean {
    return true;
  }
}
